const React = require('react')
const { useEffect, useState } = require('react')
const { Container, Row, Col } = require('reactstrap')
const { useParams } = require('react-router-dom')
const { useBlockchainData, useResponsive, BREAKPOINTS } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { Tabs, CopyButton, QRCodeButton } = require('@components')
const { ContractTab } = require('@components/contractTab')

const { AddressStatistics } = require('./statistics.address')
const { AddressTransactions } = require('./transactions.address')
const { AddressInternalTransactions } = require('./internalTransactions.address')
const { AddressTokenTransfers } = require('./tokenTransfers.address')
const { AddressNftTransfers } = require('./nftTransfers.address')
const { AddressAssets } = require('./assets.address')

require('@styles/pages/address/index.css')

const Address = () => {
    const currentUrl = window.location.href
    const { address } = useParams()
    const { network } = useNetworkConfig()
    const { getAddress } = useBlockchainData(network.name)

    const [loading, setLoading] = useState(false)
    const [accountData, setAccountData] = useState()
    const isMobile = useResponsive(BREAKPOINTS.small)

    const [activeTab, setActiveTab] = useState(() => {
        const urlHash = window.location.hash.slice(1)
        if (urlHash === 'readContract' || urlHash === 'writeContract') {
            return 'code'
        }
        if (urlHash === 'asset-multichain' || urlHash === 'asset-nfts') {
            return 'asset-tokens'
        }
        return urlHash || 'transactions'
    })

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)

                const [accountResponse] = await Promise.all([getAddress(address)])

                if (accountResponse) {
                    setAccountData(accountResponse)
                }

                setLoading(false)
            } catch (error) {
                console.error('Error fetching data:', error)
                setLoading(false)
            }
        }
        fetchData()
    }, [network, address])

    return (
        <div className='page'>
            <Container>
                <Col>
                    <Row>
                        <div className='page-header'>
                            <text
                                className='page-title'
                                style={isMobile ? { display: 'flex', flexDirection: 'column' } : {}}
                            >
                                Address&nbsp;
                                <span className='page-title-subcontent'>{address}&nbsp;</span>
                                <div style={{ display: 'inline-flex' }}>
                                    <span style={{ transform: 'scale(0.8)', transformOrigin: 'left' }}>
                                        <CopyButton
                                            id={`copy-address-${address}`}
                                            data={address}
                                            text={'Copy address'}
                                        />
                                    </span>
                                    <span style={{ transform: 'scale(0.8)', transformOrigin: 'left' }}>
                                        <QRCodeButton id={`qr-code-${address}`} url={currentUrl} text={address} />
                                    </span>
                                </div>
                            </text>
                            <div className='page-title-border' />
                        </div>
                    </Row>
                    <Row>
                        <AddressStatistics loading={loading} data={accountData} onTabChange={setActiveTab} />
                    </Row>
                    <div style={{ marginTop: '24px' }} />
                    <Tabs
                        activeTab={activeTab}
                        items={[
                            { tab: 'transactions', text: 'Transactions' },
                            ...(accountData?.internalTransactions.totalItems > 0
                                ? [{ tab: 'internaltx', text: `Internal Transactions` }]
                                : []),
                            ...(accountData?.tokenTransfers.totalItems > 0
                                ? [{ tab: 'tokentxns', text: `Token Transfers (ERC-20)` }]
                                : []),
                            ...(accountData?.nftTransfers.totalItems > 0
                                ? [{ tab: 'nfttransfers', text: `NFT Transfers` }]
                                : []),
                            ...(accountData?.type === 'SCA'
                                ? [
                                      {
                                          tab: 'code',
                                          text: `Contract`,
                                          tick: accountData.information.contract.sourceCode ? true : false
                                      }
                                  ]
                                : []),
                            { tab: 'asset-tokens', text: `Assets` }
                        ]}
                        onTabChange={setActiveTab}
                    />
                    {activeTab === 'transactions' && <AddressTransactions loading={loading} data={accountData} />}
                    {activeTab === 'internaltx' && <AddressInternalTransactions loading={loading} data={accountData} />}
                    {activeTab === 'tokentxns' && <AddressTokenTransfers loading={loading} data={accountData} />}
                    {activeTab === 'nfttransfers' && <AddressNftTransfers loading={loading} data={accountData} />}
                    {activeTab === 'code' && <ContractTab loading={loading} data={accountData} />}
                    {activeTab === 'asset-tokens' && <AddressAssets loading={loading} data={accountData} />}
                </Col>
            </Container>
        </div>
    )
}

module.exports = Address
